<template>
    <v-icon :icon="'mdi-' + name"></v-icon>
</template>

<script>
export default {
    name: 'ToolIcon',
    props: {
        name: String,
    },
};
</script>

<style scoped>
</style>
